import React from 'react';

// CORE COMPONENTS
import Form from 'core/form/Form';

// LOCAL COMPONENTS
import EmailFrequencyDay from './EmailFrequencyDay';

// MAIN COMPONENT
const EmailForm = ({
  as: FormComponent = Form,
  ...props
}) => (
  <FormComponent
    {...props}
  >
    <Form.YesNo
      name="is_active"
      label="Active"
    />
    <Form.Select
      name="is_for_wholesale"
      label="Sale Type"
      options={[
        {
          label: 'All',
          value: ''
        },
        {
          label: 'Retail',
          value: '0'
        },
        {
          label: 'Wholesale',
          value: '1'
        }
      ]}
    />
    <Form.Select
      name="new_used"
      label="Vehicle Type"
      options={[
        {
          label: 'All',
          value: ''
        },
        {
          label: 'New',
          value: '1'
        },
        {
          label: 'Pre-owned',
          value: '2'
        },
      ]}
    />
    <Form.Control
      name="email_to"
      label="To"
      required
    />
    <Form.Control
      name="email_subject"
      label="Subject"
      required
    />
    <Form.Select
      name="report_email_attachment_type_id"
      label="Attachment Type"
      lookup="reportEmailAttachmentType"
      optionKeys={{
        label: 'report_email_attachment_type_name',
        value: 'report_email_attachment_type_id'
      }}
      required
    />
    <Form.Select
      name="report_email_frequency_id"
      label="Frequency"
      lookup="reportEmailFrequency"
      optionKeys={{
        label: 'report_email_frequency_name',
        value: 'report_email_frequency_id'
      }}
      required
    />
    <EmailFrequencyDay />
    <Form.Select
      name="report_email_daterange_id"
      label="Date Range"
      lookup="reportEmailDaterange"
      optionKeys={{
        label: 'report_email_daterange_name',
        value: 'report_email_daterange_id'
      }}
      required
    />
    <Form.Textarea
      name="email_body"
      label="Body"
      required
    />
  </FormComponent>
);

// EXPORT
export default EmailForm;
